import store from "../store/index";
//------------------------
// use view extra attacks
//------------------------
export default async function useViewExtraAttacks(parm) {
  return new Promise((reject, resolve) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //-----------
    // make call
    //-----------
    this_store
      .dispatch("combat/viewExtraAttacks", parm)
      .then((extras) => {
        resolve(extras);
      })
      //-----------------
      // where api error
      //-----------------
      .catch((error) => {
        reject(error);
      });
  });
}
